import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Div, Flex } from '@fastnorth/kraken/components/layout';
import { H3 } from '@fastnorth/kraken/components/typography';
import type { SubEventProgressOverview } from '../types';
import RaceSummaryCard from './RaceSummaryCard';
import OnCourseSummaryRaceRowSkeleton from './OnCourseSummaryRaceRowSkeleton';

export type RaceProgressRacesSummaryProps = {
  emptyContent?: ReactNode;
  loadingRowCount?: number;
  subEvents: SubEventProgressOverview[];
};

const RaceProgressRacesSummary = ({
  emptyContent,
  loadingRowCount = 0,
  subEvents,
}: RaceProgressRacesSummaryProps): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event_progress_v2' });

  return (
    <Div data-testid="race-progress-on-course-summary">
      <H3 fontWeight="semibold" size="lg" spacing="0 0 4">
        {t('course_summary_heading')}
      </H3>
      {loadingRowCount > 0 ? (
        <Flex className="flex-col gap-6" data-testid="race-progress-on-course-summary-loading">
          {Array.from({ length: loadingRowCount }, (_, index) => (
            <OnCourseSummaryRaceRowSkeleton key={index} />
          ))}
        </Flex>
      ) : (
        (emptyContent ?? (
          <Flex className="flex-col gap-6" data-testid="race-progress-on-course-summary-cards">
            {subEvents.map((subEvent) => (
              <RaceSummaryCard key={subEvent.subEventId} subEvent={subEvent} />
            ))}
          </Flex>
        ))
      )}
    </Div>
  );
};

export default RaceProgressRacesSummary;
